import moment from "moment";
import { useTranslation } from "react-i18next";
import GetTipoMedico from "../../../utils/getTipoMedico";

export default function DataSharev2({
    component=null,
    cita, 
    title
}){
    const { t } = useTranslation();
    return (
        <>
            <h5 className="colorLink mb-2 text-center">{title}</h5> 
            {component}
            {!component && <span className="colorLabel text-center d-block fw-medium">{moment(cita.scheduleDTO.dateTimeInit, "YYYY-MM-DDTHH:mm:ss").format("DD MMMM YYYY HH:mm")}</span>                       }

            <div className="mt-5">
                {
                    cita?.patientDTO?.company?.id === 1 && 
                        <span className="colorLabel">{t('problemas_video_call')}</span>
                }
                {
                    cita?.patientDTO?.company?.id === 2 && 
                    <span className="colorLabel">{t('problemas_video_call_colombia')}</span> 
                }
            </div>
            {
                cita.patientDTO.account.helpCenter && 
                <div className="mt-4">
                    <span className="colorLabel fw-medium">{cita.patientDTO.account.helpCenter}</span>
                </div>
            }
            <div className="mt-3">
                <span className="d-block colorLabel">
                    <GetTipoMedico idSpeciality={cita.speciality.id} />{`: ${cita.scheduleDTO.name_doctor}`}
                </span>
            </div>
        </>
    )
}